module.exports = __webpack_public_path__ + "img/memberIcon.bae593c9.png";